import PropTypes from 'prop-types';
import {
  Paper,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

const headerStyle = {
  fontSize: '0.725rem',
  fontWeight: 700,
  color: '#64748b',
  letterSpacing: '0.05em',
  py: 1.5,
  borderBottom: '1px solid #e2e8f0',
};

const bodyStyle = {
  fontSize: '0.875rem',
  color: '#334155',
  py: 1.75,
  borderBottom: '1px solid #f1f5f9',
};

const UserUsageTable = ({ heading, rows }) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 3,
        borderRadius: 2,
        borderColor: '#e2e8f0',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.05)',
        width: '100%',
        boxSizing: 'border-box'
      }}
    >
      <Box sx={{ mb: 2.5 }}>
        <Typography variant="h6" fontWeight={600} sx={{ color: '#0f172a', letterSpacing: '-0.01em' }}>
          User Usage & Cost Breakdown
        </Typography>
        <Typography variant="body2" sx={{ color: '#64748b', mt: 0.5 }}>
          Detailed breakdown of token consumption, proposals generated, and total spend per top 5 users
        </Typography>
      </Box>

      <TableContainer sx={{ border: '1px solid #e2e8f0', borderRadius: 1.5, overflow: 'hidden' }}>
        <Table sx={{ minWidth: 650 }} aria-label="user usage table">
          <TableHead sx={{ backgroundColor: '#f8fafc' }}>
            <TableRow>
              {heading.map(title => (
                <TableCell sx={headerStyle} key={title}>{title}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow
                key={index}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                  '&:hover': { backgroundColor: '#f1f5f9' },
                  transition: 'background-color 0.15s ease'
                }}
              >
                <TableCell sx={{ ...bodyStyle, color: '#94a3b8', fontWeight: 600 }}>
                  {index + 1}
                </TableCell>

                {Object.keys(row).map((key, i) => (
                  ((!key.endsWith('id')) &&
                    <TableCell sx={bodyStyle} key={i}>
                      {row[key]}
                    </TableCell>
                  )
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

UserUsageTable.propTypes = {
  heading: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
};
export default UserUsageTable;